const PUBLIC_ROUTES = Object.freeze({
  makeupRecommendations: '/makeup-recommendations',
  faceContour: '/makeup-recommendations/face-contour',
  noseContour: '/makeup-recommendations/nose-contour',
  blushPlacement: '/makeup-recommendations/blush-placement',
  eyebrows: '/makeup-recommendations/eyebrows',
  eyeliner: '/makeup-recommendations/eyeliner',
  shadeMatch: '/makeup-recommendations/shade-match',
});

const LEGACY_MAKEUP_REDIRECTS = Object.freeze([
  { source: '/makeup-recommendations', destination: PUBLIC_ROUTES.faceContour, permanent: true },
  { source: '/makeup_recommendations', destination: PUBLIC_ROUTES.faceContour, permanent: true },
  { source: '/makeup_recommendations/face-contour', destination: PUBLIC_ROUTES.faceContour, permanent: true },
  { source: '/makeup_recommendations/face_contour', destination: PUBLIC_ROUTES.faceContour, permanent: true },
  { source: '/makeup-recommendations/face_contour', destination: PUBLIC_ROUTES.faceContour, permanent: true },
  { source: '/makeup_recommendations/nose-contour', destination: PUBLIC_ROUTES.noseContour, permanent: true },
  { source: '/makeup_recommendations/nose_contour', destination: PUBLIC_ROUTES.noseContour, permanent: true },
  { source: '/makeup-recommendations/nose_contour', destination: PUBLIC_ROUTES.noseContour, permanent: true },
  { source: '/makeup_recommendations/blush-placement', destination: PUBLIC_ROUTES.blushPlacement, permanent: true },
  { source: '/makeup_recommendations/blush_placement', destination: PUBLIC_ROUTES.blushPlacement, permanent: true },
  { source: '/makeup-recommendations/blush_placement', destination: PUBLIC_ROUTES.blushPlacement, permanent: true },
  { source: '/makeup_recommendations/eyebrows', destination: PUBLIC_ROUTES.eyebrows, permanent: true },
  { source: '/makeup_recommendations/eyeliner', destination: PUBLIC_ROUTES.eyeliner, permanent: true },
  { source: '/makeup_recommendations/shade-match', destination: PUBLIC_ROUTES.shadeMatch, permanent: true },
  { source: '/makeup_recommendations/shade_match', destination: PUBLIC_ROUTES.shadeMatch, permanent: true },
  { source: '/makeup-recommendations/shade_match', destination: PUBLIC_ROUTES.shadeMatch, permanent: true },
]);

const LEGACY_ROUTE_REDIRECTS = Object.freeze([
  ...LEGACY_MAKEUP_REDIRECTS,
  { source: '/account_cancelled', destination: '/account-cancelled', permanent: true },
  { source: '/api_quickstart', destination: '/api-quickstart', permanent: true },
]);

module.exports = {
  LEGACY_MAKEUP_REDIRECTS,
  LEGACY_ROUTE_REDIRECTS,
  PUBLIC_ROUTES,
};
